<template>
  <div class="contest-submit-page-wrapper">
    <div class="container">
      <div class="contest-submit-page-container">
        <div class="contest-submit-main-content">
          <div class="card w-100">
            <h3 v-if="contest">Submitting to contest: {{ contest.contest.name }}</h3>
            <div class="submit-image-box-display" v-if="publishedImages">
              <SubmitImageBox v-for="image in publishedImages" :key="image.id" :id="image.id"
                              :name="image.image_name" :storage_path="image.path"
                              :allow-more-selection="selectionsAllowed" @toggle="onToggleImage"/>
            </div>
          </div>
        </div>
        <div class="contest-submit-sidebar">
          <div class="card w-100">
            <h3 v-if="contest">Selected images ({{ contest.contest.image_limit }} allowed)</h3>
            <p v-if="selectedImages.length === 0">
              No images selected
            </p>

            <ul>
              <li v-for="imgId in selectedImages" :key="imgId">
                {{ getImageFromListById(imgId).image_name }}
              </li>
            </ul>
            <button v-if="selectedImages.length > 0" class="button-primary my-10" @click="submitImages">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import apiService from '@/services/apiService';
import {onMounted, ref} from 'vue';
import SubmitImageBox from '../common/SubmitImageBox.vue';
import {useRouter} from 'vue-router';

const {id} = defineProps({
  id: String
})

const router = useRouter();

const allImages = ref([])
const publishedImages = ref([])
const selectedImages = ref([])
const contest = ref(null)
const selectionsAllowed = ref(true);

onMounted(async () => {
  const all_res = await apiService.getImagesByUser()
  allImages.value = all_res;

  publishedImages.value = allImages.value.filter(
      img => img.published === true && img.allowed_by_moderator === true
  )

  const cont_res = await apiService.getContestById(id);
  contest.value = cont_res;

  console.log(contest.value);

})

function onToggleImage({id, selected}) {
  if (selected) {
    if (selectedImages.value.length >= contest.value.contest.image_limit) {
      return
    }
    selectedImages.value.push(id)
  } else {
    selectedImages.value = selectedImages.value.filter(i => i !== id)
  }
  selectionsAllowed.value = selectedImages.value.length < contest.value.contest.image_limit;
}

function getImageFromListById(id) {
  return publishedImages.value.find(img => img.id === id) || null
}

async function submitImages() {
  await apiService.submitImages(
      contest.value.contest.id,
      {
        images: selectedImages.value
      }
  );

  router.back();
}

</script>

<style scoped>
.contest-submit-page-wrapper {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  color: #323232;
}

.contest-submit-page-container {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: start;
  justify-content: start;
}

.contest-submit-main-content {
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-right: 1rem;
}

.contest-submit-sidebar {
  width: 30%;
}

.submit-image-box-display {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  justify-content: space-around;
}
</style>